//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbModal from '@/elements/modal/rb-modal.vue'
const RbEmbeddedVideo = () => import('@/elements/editorial/video/rb-embedded-video.vue')

export default {
  name: 'video-button',
  components: { RbModal, RbEmbeddedVideo },
  props: {
    videoId: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  data() {
    return { modalActive: false }
  },
  methods: {
    showModal() {
      this.modalActive = true
    },
    closeModal() {
      this.modalActive = false
    },
  },
}
